import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fRef } from '../../utils/React.js';
import { hostClass } from './Slider.styles.js';

/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/label-has-associated-control */
// For internal use only, means interaction between Presentation and Wrapper ...

var CurrentSlider;

(function (CurrentSlider) {
  CurrentSlider["None"] = "none";
  CurrentSlider["Lower"] = "lower";
  CurrentSlider["Upper"] = "upper";
})(CurrentSlider || (CurrentSlider = {}));

var defaultProps = {
  showLabel: true,
  showThumb: true,
  look: "singleSlider",
  minValue: 0
};
var SliderPresentation = fRef(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;

  var id = props.id,
      name = props.name,
      className = props.className,
      htmlAttrs = props.htmlAttrs,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      value = props.value,
      minValue = props.minValue,
      maxValue = props.maxValue,
      disabled = props.disabled,
      label = props.label,
      showLabel = props.showLabel,
      step = props.step,
      helperMinValue = props.helperMinValue,
      helperMaxValue = props.helperMaxValue,
      showThumb = props.showThumb,
      look = props.look,
      _onFocus = props.onFocus,
      hasFocusOnSlider = props.hasFocusOnSlider,
      onTrackClick = props.onTrackClick,
      sliderTrackContainerRef = props.sliderTrackContainerRef,
      sliderMarkerTrackColorDummyRef = props.sliderMarkerTrackColorDummyRef,
      hostRef = props.hostRef,
      lowerSliderThumbRef = props.lowerSliderThumbRef,
      upperSliderThumbRef = props.upperSliderThumbRef,
      onMouseDown = props.onMouseDown,
      onKeyDown = props.onKeyDown,
      sliderMarkerTrackBaseColor = props.sliderMarkerTrackBaseColor,
      lowerSliderThumbPercentage = props.lowerSliderThumbPercentage,
      upperSliderThumbPercentage = props.upperSliderThumbPercentage,
      onHelperMinClick = props.onHelperMinClick,
      onHelperMaxClick = props.onHelperMaxClick,
      handleOnSliderBlur = props.handleOnSliderBlur;

  var getSliderMarkerTrackStyle = function getSliderMarkerTrackStyle() {
    // We need to know the color of the stepped slider markings, dependently on the theming
    // We have defined a dummy component sliderMarkerTrackColorDummy we styled in the styles.ts file
    // and get the computed color.
    var markerStepPercentage;

    if (step) {
      var color = sliderMarkerTrackBaseColor;
      markerStepPercentage = step / (maxValue - minValue) * 100;
      return {
        style: {
          background: "repeating-linear-gradient(90deg,\n                ".concat(color, ", ").concat(color, " 4px, rgba(0,0,0,0) 4px, rgba(0,0,0,0) ").concat(markerStepPercentage, "%)")
        }
      };
    }

    return {
      style: {
        backgroundColor: sliderMarkerTrackBaseColor
      }
    };
  };

  return /*#__PURE__*/React.createElement(Host, Object.assign({
    id: id,
    name: name,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__disabled"), disabled), _cleanupClassObject))
  }, htmlAttrs, {
    tabIndex: -1,
    // onFocus={onFocus}
    // onBlur={(e)=> onBlur(e, name)}
    onBlur: handleOnSliderBlur,
    ref: hostRef,
    isStencilHost: isStencilHost,
    onKeyDown: onKeyDown,
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    "aria-valuenow": CurrentSlider.Upper === hasFocusOnSlider ? value[1] : value[0],
    "aria-valuetext": "Current focus on ".concat(hasFocusOnSlider),
    "aria-label": label
  }), label && showLabel && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-label")
  }, /*#__PURE__*/React.createElement("label", null, label)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-container"),
    onClick: onTrackClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-track-container"),
    ref: sliderTrackContainerRef
  }, step && [
  /*#__PURE__*/
  // overlay for the slider markings, renderd as a repeating linear gradient.
  React.createElement("div", Object.assign({
    className: "".concat(hostClass, "-marker-track"),
    key: "slider-marker-track"
  }, getSliderMarkerTrackStyle())),
  /*#__PURE__*/
  // to get the color of the slider markings
  React.createElement("div", {
    className: "".concat(hostClass, "-track-marker-color-dummy"),
    ref: sliderMarkerTrackColorDummyRef,
    key: "slider-track-marker-color-dummy"
  }),
  /*#__PURE__*/
  // we need those two elements to hide slider marks at the beginning and end
  // of the slider-marker-track.
  React.createElement("div", {
    className: "".concat(hostClass, "-track-start"),
    key: "slider-track-start"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-track-end"),
    key: "slider-track-end"
  })], look === "singleSlider" && [/*#__PURE__*/React.createElement("div", {
    key: "".concat(hostClass, "-track-lower").concat(lowerSliderThumbPercentage),
    className: "".concat(hostClass, "-track"),
    style: {
      width: "".concat(lowerSliderThumbPercentage, "%")
    }
  })], look === "rangeSlider" && upperSliderThumbPercentage > lowerSliderThumbPercentage && [/*#__PURE__*/React.createElement("div", {
    key: "".concat(hostClass, "-track-upper").concat(upperSliderThumbPercentage),
    className: "".concat(hostClass, "-track"),
    style: {
      width: "".concat(upperSliderThumbPercentage - lowerSliderThumbPercentage, "%"),
      left: "".concat(lowerSliderThumbPercentage, "%")
    }
  })]), /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "_").concat(CurrentSlider.Lower),
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-thumb-container"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__focus"), hasFocusOnSlider === CurrentSlider.Lower), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-thumb__invisible"), !showThumb || lowerSliderThumbPercentage < 0 || lowerSliderThumbPercentage > 100), _cleanupClassObject2)),
    ref: lowerSliderThumbRef,
    onMouseDown: onMouseDown,
    onTouchStart: onMouseDown,
    onFocus: function onFocus(e) {
      return _onFocus(e, name);
    },
    // onBlur={handleOnSliderBlur}
    style: {
      left: "".concat(lowerSliderThumbPercentage, "%"),
      zIndex: hasFocusOnSlider === CurrentSlider.Lower ? 6 : 5
    },
    tabIndex: disabled ? -1 : (htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.tabIndex) || 0
  }, /*#__PURE__*/React.createElement("svg", {
    className: "".concat(hostClass, "-thumb"),
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "15"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "_").concat(CurrentSlider.Upper),
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-thumb-container"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "__focus"), hasFocusOnSlider === CurrentSlider.Upper), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-thumb__invisible"), !showThumb || upperSliderThumbPercentage < lowerSliderThumbPercentage || upperSliderThumbPercentage < 0 || upperSliderThumbPercentage > 100 || look !== "rangeSlider"), _cleanupClassObject3)),
    ref: upperSliderThumbRef,
    onMouseDown: onMouseDown,
    onTouchStart: onMouseDown,
    onFocus: function onFocus(e) {
      return _onFocus(e, name);
    },
    // onBlur={handleOnSliderBlur}
    style: {
      left: "".concat(upperSliderThumbPercentage, "%"),
      zIndex: hasFocusOnSlider === CurrentSlider.Upper ? 6 : 5
    },
    tabIndex: disabled ? -1 : (htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.tabIndex) + 1 || 0
  }, /*#__PURE__*/React.createElement("svg", {
    className: "".concat(hostClass, "-thumb"),
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "15"
  })))), (helperMinValue || helperMaxValue) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-helper")
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onHelperMinClick,
    className: "".concat(hostClass, "-helper-label-minvalue")
  }, helperMinValue), /*#__PURE__*/React.createElement("div", {
    onClick: onHelperMaxClick,
    className: "".concat(hostClass, "-helper-label-maxvalue")
  }, helperMaxValue)));
}, defaultProps);

export { CurrentSlider, SliderPresentation, defaultProps };
